import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: new URLSearchParams(window.location.search).get('lang') || 'de',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en'
})

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync () {
  return axios.get('/feedbackform/data/languages').then(response => {
    let msgs = response.data
    i18n.setLocaleMessage("de", msgs.de)
    i18n.setLocaleMessage("en", msgs.en)
    setI18nLanguage(new URLSearchParams(window.location.search).get('lang') || 'de')
  })
}
